<template>

        <!-- Ec Header Button Start -->
        <div class="align-self-center">
            <div class="ec-header-bottons">
                <!-- Header User Start -->

                <div class="ec-header-user dropdown" v-if=" ! auth.isLoggedIn()" data-bs-toggle="modal" data-bs-target="#loginOrRegister">
                    <button class="dropdown-toggle" data-bs-toggle="dropdown" v-if="type == 'mobile'"><i
                        class="fi-rr-user"></i></button>

                    <button class="dropdown-toggle button" data-bs-toggle="dropdown"
                            v-if="type != 'mobile'">
                        <span>دخول  / تسجيل المستخدمين</span>
                    </button>
                </div>

<!--                <div class="ec-header-user dropdown"  v-if=" ! auth.isLoggedIn()">-->


<!--                    <button class="dropdown-toggle" data-bs-toggle="dropdown" v-if="type == 'mobile'"><i-->
<!--                        class="fi-rr-user"></i></button>-->

<!--                    <button class="dropdown-toggle button" data-bs-toggle="dropdown"-->
<!--                            v-if="type != 'mobile'">-->
<!--                        <span>دخول  / تسجيل المستخدمين</span>-->
<!--                        <i class="fi fi-rr-angle-small-down"></i>-->
<!--                    </button>-->

<!--                    <ul class="dropdown-menu dropdown-menu-right">-->

<!--                        <li class="dropdown-item">-->
<!--                            <i></i>-->
<!--                            <router-link :to="{ name:'login', params: { lang : $i18n.locale } }" >{{ $t('Sign in')}}</router-link>-->
<!--                        </li>-->
<!--                        <li class="dropdown-item">-->
<!--                            <router-link :to="{ name:'register', params: { lang : $i18n.locale } }" >{{ $t('Sign Up')}}</router-link>-->
<!--                        </li>-->
<!--                        <li class="dropdown-item">-->
<!--                            <router-link :to="{ name:'password.reset', params: { lang : $i18n.locale } }"  class="forgot-password">-->
<!--                                {{  $t('Forgot Password?') }}-->
<!--                            </router-link>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </div>-->
<!--                -->
                <div class="ec-header-user dropdown"  v-if=" auth.isLoggedIn()">


                    <button class="dropdown-toggle" data-bs-toggle="dropdown" v-if="type == 'mobile'"><i
                        class="fi-rr-user"></i></button>


                    <button class="dropdown-toggle button" data-bs-toggle="dropdown"
                            v-if="type != 'mobile'">
                        <span v-if="auth.isLoggedIn()">
                            {{ $t('Hello') }}, {{ auth.user('name') }}
                        <i class="fi fi-rr-angle-small-down"></i>
                        </span>
                    </button>

                    <ul class="dropdown-menu dropdown-menu-right">
<!--                        <li class="dropdown-item">-->
<!--                            <i></i>-->
<!--                            <router-link :to="{'name' : 'activation', params: { lang : $i18n.locale }}" v-if=" ! auth.user('verified')" >-->
<!--                                {{ $t('Activate your membership') }}-->
<!--                            </router-link>-->
<!--                        </li>-->
<!--                        <li class="dropdown-item">-->
<!--                            <router-link :to="{ name: 'users.change_password', params: { lang : $i18n.locale } }" >-->
<!--                                {{ $t('Change password')}}-->
<!--                            </router-link>-->
<!--                        </li>-->
                        <li class="dropdown-item">
                            <router-link :to="{ name: 'user.edit', params: { lang : $i18n.locale } }" >
                                {{ $t('Edit My Information')}}
                            </router-link>
                        </li>
                        <li class="dropdown-item">
                            <router-link :to="{ name: 'addresses.index', params: { lang : $i18n.locale } }" >
                                {{ $t('Addresses')}}
                            </router-link>
                        </li>
                        <li class="dropdown-item">
                            <router-link :to="{ name: 'orders.index', params: { lang : $i18n.locale } }" >
                                {{ $t('Your Orders')}}
                            </router-link>
                        </li>
                        <li class="dropdown-item">
                            <a href="#" class="" @click="auth.logout()" >{{ $t('Log out') }}</a>
                        </li>
                    </ul>

                </div>

                <!-- Header User End -->
            </div>
        </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    inject: ['auth'],
    props:['type'],
    watch: {
        '$userLoggedIn.value': function (newVal) {
            if(newVal === true){

                const cartItems = this.$user.value?.cart_items ?? [];
                // console.log( '--- cartItems' );
                // console.log( this.$user.value.cart_items );
                // console.log( cartItems );
                //
                // console.log('Type of cartItems:', typeof cartItems);
                // console.log('cartItems:', cartItems);
                const productsArray = Object.values(cartItems);

                productsArray?.forEach(product => {
                    this.autoAddToCart(product);
                });

            }
        },
    },
    computed: {
        ...mapGetters(['cartItems']), // Map the cartItems getter
        total() {
            return this.cartItems.reduce((total, product) => total + (product?.cart?.quantity || 0) * product.price, 0);
        },
    },
    methods: {
        ...mapActions(['addToCart', 'removeFromCart','autoAddToCart']), // Map the addToCart and removeFromCart actions
        // Your other methods here
    },
};

</script>

<style scoped>
/* Add your component-specific styles here */
</style>
